import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'formatBeEdid'
})
export class FormatBeEdidPipe implements PipeTransform {
  private ANZAHL_STELLEN = 2;

  constructor() {
  }

  transform(bedid: number): string {
    if (bedid === 0) {
      return '00';
    }
    if (!bedid) {
      return null;
    }
    return (bedid + Math.pow(10, this.ANZAHL_STELLEN) + "").slice(1);
  }

}
